import React from 'react';
import { motion } from 'framer-motion';
const orbs = [{
  size: 600,
  color: 'rgba(0, 102, 255, 0.08)',
  initialX: '10%',
  initialY: '20%',
  animateX: ['10%', '40%', '20%', '50%', '10%'],
  animateY: ['20%', '50%', '80%', '30%', '20%'],
  duration: 45
}, {
  size: 500,
  color: 'rgba(0, 212, 255, 0.06)',
  initialX: '70%',
  initialY: '60%',
  animateX: ['70%', '30%', '60%', '40%', '70%'],
  animateY: ['60%', '20%', '40%', '80%', '60%'],
  duration: 55
}, {
  size: 400,
  color: 'rgba(0, 102, 255, 0.05)',
  initialX: '50%',
  initialY: '80%',
  animateX: ['50%', '80%', '30%', '60%', '50%'],
  animateY: ['80%', '40%', '60%', '20%', '80%'],
  duration: 50
}];
export function AnimatedBackground() {
  return <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-id="element-11">
      {orbs.map((orb, i) => <motion.div key={i} className="absolute rounded-full" style={{
      width: orb.size,
      height: orb.size,
      background: `radial-gradient(circle, ${orb.color} 0%, transparent 70%)`,
      left: orb.initialX,
      top: orb.initialY,
      transform: 'translate(-50%, -50%)'
    }} animate={{
      left: orb.animateX,
      top: orb.animateY
    }} transition={{
      duration: orb.duration,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-12" />)}

      {/* Subtle dot grid overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjAuNSIgZmlsbD0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIvPjwvc3ZnPg==')] opacity-60" data-id="element-13"></div>
    </div>;
}